import { Entity, EntityTypeName, Person, Space } from '@shapeable/types';
import { entityTypeNameFor } from '@shapeable/utils';

const HUB_APP_URL = 'https://hub.doingco.org';

const HUB_VIEW_BY_ENTITY_TYPE: Partial<Record<EntityTypeName, string>> = {
  ImpactStory: 'doings',
  Space: 'spaces',
  Person: 'people',
};

type ImpactStoryPageEntity = Entity & {
  people?: Person[];
};

export function isOwnPersonPage(
  pageEntity: Entity | null | undefined,
  activePerson?: Person | null | undefined,
): boolean {
  return entityTypeNameFor(pageEntity) === 'Person' && activePerson?.slug === pageEntity?.slug;
}

export function getHubEditHref(
  pageEntity: Entity | null | undefined,
  activePerson?: Person | null | undefined,
): string | null {
  if (!pageEntity?.slug) {
    return null;
  }

  const entityTypeName = entityTypeNameFor(pageEntity);

  if (isOwnPersonPage(pageEntity, activePerson)) {
    return `${HUB_APP_URL}/?view=profile`;
  }

  const view = HUB_VIEW_BY_ENTITY_TYPE[entityTypeName];

  if (!view) {
    return null;
  }

  return `${HUB_APP_URL}/?view=${view}&slug=${pageEntity.slug}`;
}

export function canEditEntityPage(
  pageEntity: Entity | null | undefined,
  activePerson: Person | null | undefined,
  isAvailable?: boolean,
): boolean {

  if (!pageEntity || !isAvailable || !activePerson?.slug) {
    return false;
  }

  if (activePerson.canAdmin) {
    return true;
  }

  const personSlug = activePerson.slug;
  const entityTypeName = entityTypeNameFor(pageEntity);

  if (entityTypeName === 'Space') {
    const memberships = (pageEntity as Space).members || [];

    return memberships.some((person) => person?.slug === personSlug);
  }

  if (entityTypeName === 'ImpactStory') {
    const people = (pageEntity as ImpactStoryPageEntity).people || [];

    return people.some((person) => person.slug === personSlug);
  }

  if (entityTypeName === 'Person') {
    return personSlug === pageEntity.slug;
  }

  return false;
}
